import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "a-Stepper" }
const _hoisted_2 = { class: "a-Stepper__iconContainer" }
const _hoisted_3 = ["data-qa"]
const _hoisted_4 = { class: "a-Stepper__iconContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      "data-qa": 'stepper-decrease',
      class: _normalizeClass(["a-Stepper__control", { 'inactive': !_ctx.state.canDecrease }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleStateChangeEmit(_ctx.StepperAction.DECREASE))),
      onKeydown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleKeypress($event, _ctx.StepperAction.DECREASE))),
      tabindex: "0"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_IconComponent, {
          "icon-id": _ctx.IconName.Minus
        }, null, 8, ["icon-id"])
      ])
    ], 34),
    _withDirectives(_createElementVNode("div", {
      class: "a-Stepper__amount",
      "data-qa": _ctx.PerformanceQASelectors.STEPPER_AMOUNT
    }, _toDisplayString(_ctx.state.amount), 9, _hoisted_3), [
      [_vShow, _ctx.showAmount]
    ]),
    _createElementVNode("div", {
      "data-qa": 'stepper-increase',
      class: _normalizeClass(["a-Stepper__control", { 'inactive': !_ctx.state.canIncrease }]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleStateChangeEmit(_ctx.StepperAction.INCREASE))),
      onKeydown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleKeypress($event, _ctx.StepperAction.INCREASE))),
      tabindex: "0"
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_IconComponent, {
          "icon-id": _ctx.IconName.Plus
        }, null, 8, ["icon-id"])
      ])
    ], 34)
  ]))
}